import React, { useRef, useState } from "react";
import { Overlay, Popover, Row, Col, Button } from "react-bootstrap";
import { useTheme } from "@/hooks/useTheme";
import { FaPalette, FaMoon, FaSun } from "react-icons/fa";
import "./ThemeMenu.scss";

const themes = [
  { name: "enmax-blue", color: "#0F487A", label: "Blue" },
  { name: "enmax-burgundy", color: "#7E3E49", label: "Burgundy" },
  { name: "enmax-green", color: "#B4C83C", label: "Green" },
  { name: "enmax-gold", color: "#FFBF00", label: "Gold" },
  { name: "enmax-red", color: "#E31936", label: "Red" },
  { name: "enmax-teal", color: "#009DBA", label: "Teal" },
];

const ThemeMenu: React.FC = () => {
  const { accent, mode, toggleMode, setAccentTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLButtonElement | null>(null);

  return (
    <>
      <Button
        ref={ref}
        variant="link"
        className="text-light p-1 me-2"
        onClick={() => setOpen((v) => !v)}
        aria-label="Select theme"
        title="Change theme"
      >
        <FaPalette size={20} />
      </Button>

      <Overlay
        target={ref.current}
        show={open}
        placement="bottom-end"
        rootClose
        onHide={() => setOpen(false)}
      >
        <Popover id="theme-popover" className="theme-popover">
          <Popover.Body>
            <div className="theme-swatches mb-2">
              <Row xs={3} className="g-2">
                {themes.map((t) => (
                  <Col key={t.name} className="text-center">
                    <button
                      className={`swatch ${accent === t.name ? "active" : ""}`}
                      style={{ backgroundColor: t.color }}
                      title={t.label}
                      onClick={() => setAccentTheme(t.name)}
                    />
                  </Col>
                ))}
              </Row>
            </div>
            <div className="d-flex justify-content-center mt-2">
              <Button
                variant="outline-secondary"
                size="sm"
                className="d-flex align-items-center gap-2"
                onClick={toggleMode}
              >
                {mode === "light" ? (
                  <>
                    <FaMoon /> Dark Mode
                  </>
                ) : (
                  <>
                    <FaSun /> Light Mode
                  </>
                )}
              </Button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
    </>
  );
};

export default ThemeMenu;